














export default
	name: 'accordionWrapper'

	props:
		block: Object

	computed:
		paneWidth: ->
			switch @block.maxWidth
				when "max-w-full" then "max-w"
				when "max-w" then "max-w-medium"
				else "max-w-small"

		classes: -> [
			@block.maxWidth
			@block.textAlignment || 'center'
		]

